export const FETCH_ROLE_PERMISSION_LOADING = "FETCH_ROLE_PERMISSION_LOADING";
export const FETCH_ROLE_PERMISSION_SUCCESS = "FETCH_ROLE_PERMISSION_SUCCESS";
export const FETCH_ROLE_PERMISSION_ERROR = "FETCH_ROLE_PERMISSION_ERROR";
